import { render, staticRenderFns } from "./EditStationParameters.vue?vue&type=template&id=0c520f27"
import script from "./EditStationParameters.vue?vue&type=script&lang=js"
export * from "./EditStationParameters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports